export default __webpack_public_path__ + "static/media/Mail sent.841804ea.gif";